goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Archive$default");
shadow.js.shim.module$$carbon$icons_react$es$Archive$default = shadow.js.require(347, {}).default;
